(() => {
const $dc2d63b917c60329$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

const $26fc349e92d9489e$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;


const $a9ec4c6371c8c8ef$export$8793edee2d425525 = ()=>{};
const $a9ec4c6371c8c8ef$export$ea6e51872ab1b721 = (v)=>v;



const $b5fe3643ba3c2da8$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);


function $9b3af257d77590ba$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $26fc349e92d9489e$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}
function $9b3af257d77590ba$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $9b3af257d77590ba$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}



const $2600ec0fa268729d$export$7e4aa119212bc614 = (value)=>typeof value === "number";


const $0f92e8df025f9218$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $2600ec0fa268729d$export$7e4aa119212bc614)(easing[0]);


const $50822229f89c800a$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


function $e7e8fb4e721c4127$export$41c5e731255a462(easing, i) {
    return (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing[(0, $50822229f89c800a$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


const $c39040460f3b0b9e$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


function $f9be231e4d7a00b5$export$89e29e4ab65e70a9(output, input = (0, $9b3af257d77590ba$export$24dbcec0b26e6d9d)(output.length), easing = (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $9b3af257d77590ba$export$dafee61230cf05c6)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $c39040460f3b0b9e$export$7d15b64cf5a3a4c4)(0, 1, (0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(input[i], input[i + 1], t));
        const segmentEasing = (0, $e7e8fb4e721c4127$export$41c5e731255a462)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $26fc349e92d9489e$export$2c9e8a9632a706b2)(output[i], output[i + 1], progressInRange);
    };
}

const $c0efdae2be78a137$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);



/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $0c9f2a04764915a5$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $0c9f2a04764915a5$var$subdivisionPrecision = 0.0000001;
const $0c9f2a04764915a5$var$subdivisionMaxIterations = 12;
function $0c9f2a04764915a5$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $0c9f2a04764915a5$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $0c9f2a04764915a5$var$subdivisionPrecision && ++i < $0c9f2a04764915a5$var$subdivisionMaxIterations);
    return currentT;
}
function $0c9f2a04764915a5$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721;
    const getTForX = (aX)=>$0c9f2a04764915a5$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $0c9f2a04764915a5$var$calcBezier(getTForX(t), mY1, mY2);
}


const $fecf794dcc504830$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $c39040460f3b0b9e$export$7d15b64cf5a3a4c4)(0, 1, rounded / steps);
    };



const $ead554a12e40dce0$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $2600ec0fa268729d$export$7e4aa119212bc614)(easing[0]);

const $6a6d195304e4357d$export$f6e2535fb5126e54 = (value)=>typeof value === "function";


const $feb0fd98b03164bf$var$namedEasings = {
    ease: (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.0, 0.0, 0.58, 1.0)
};
const $feb0fd98b03164bf$var$functionArgsRegex = /\((.*?)\)/;
function $feb0fd98b03164bf$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $ead554a12e40dce0$export$77290801a62f77a2)(definition)) return (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(...definition);
    // If we have a predefined easing function, return
    const namedEasing = $feb0fd98b03164bf$var$namedEasings[definition];
    if (namedEasing) return namedEasing;
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $feb0fd98b03164bf$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $fecf794dcc504830$export$be3f796aed065412)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721;
}


class $77d743c5fbee771c$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration, delay: delay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).repeat, offset: offset, direction: direction = "normal", autoplay: autoplay = true } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing;
        if ((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721) : (0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $f9be231e4d7a00b5$export$89e29e4ab65e70a9)(keyframes, offset, (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing.map((0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)) : (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        if (autoplay) this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}


var $82adf2b309a976d9$export$491112666e282270 = function() {};
var $82adf2b309a976d9$export$f5708dca728d7177 = function() {};


/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $091e5423bab70e58$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}


const $4ac2d59feaf07851$var$data = new WeakMap();
function $4ac2d59feaf07851$export$213eea93596b44f(element) {
    if (!$4ac2d59feaf07851$var$data.has(element)) $4ac2d59feaf07851$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $4ac2d59feaf07851$var$data.get(element);
}
function $4ac2d59feaf07851$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $091e5423bab70e58$export$8cea36d14ee64562)());
    return motionValues.get(name);
}


function $2bf1343b4ac164eb$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $2bf1343b4ac164eb$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $4be6463a6552f378$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $4be6463a6552f378$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $4be6463a6552f378$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $4be6463a6552f378$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $4be6463a6552f378$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $4be6463a6552f378$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721)
    },
    skew: $4be6463a6552f378$var$rotation
};
const $4be6463a6552f378$export$a9dad2abc3d443d = new Map();
const $4be6463a6552f378$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $4be6463a6552f378$var$transforms = [
    "x",
    "y",
    "z"
];
$4be6463a6552f378$var$order.forEach((name)=>{
    $4be6463a6552f378$export$a9a762b9618d4a18.forEach((axis)=>{
        $4be6463a6552f378$var$transforms.push(name + axis);
        $4be6463a6552f378$export$a9dad2abc3d443d.set($4be6463a6552f378$export$7bbd29b1fa8b68d4(name + axis), $4be6463a6552f378$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $4be6463a6552f378$export$11410fe03e8c4042 = (a, b)=>$4be6463a6552f378$var$transforms.indexOf(a) - $4be6463a6552f378$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $4be6463a6552f378$var$transformLookup = new Set($4be6463a6552f378$var$transforms);
const $4be6463a6552f378$export$8a546e9da811625d = (name)=>$4be6463a6552f378$var$transformLookup.has(name);
const $4be6463a6552f378$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($4be6463a6552f378$export$97b5d3c90609c212[name]) name = $4be6463a6552f378$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $4ac2d59feaf07851$export$213eea93596b44f)(element);
    (0, $2bf1343b4ac164eb$export$20e507e47fae79fd)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $4be6463a6552f378$export$785216816cb6f870(transforms);
};
const $4be6463a6552f378$export$785216816cb6f870 = (transforms)=>transforms.sort($4be6463a6552f378$export$11410fe03e8c4042).reduce($4be6463a6552f378$var$transformListToString, "").trim();
const $4be6463a6552f378$var$transformListToString = (template, name)=>`${template} ${name}(var(${$4be6463a6552f378$export$7bbd29b1fa8b68d4(name)}))`;


const $ccd27e317ff74620$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $ccd27e317ff74620$export$7a740cb9e3dd106d = new Set();
function $ccd27e317ff74620$export$9fdd8c2f6f59adb0(name) {
    if ($ccd27e317ff74620$export$7a740cb9e3dd106d.has(name)) return;
    $ccd27e317ff74620$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $4be6463a6552f378$export$a9dad2abc3d443d).has(name) ? (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}


const $b41dbcd6c6617a69$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};




const $15b73f7aeef5597f$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $15b73f7aeef5597f$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $15b73f7aeef5597f$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($15b73f7aeef5597f$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $15b73f7aeef5597f$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $15b73f7aeef5597f$var$results = {};
const $15b73f7aeef5597f$export$cde6a56f9669daf6 = {};
for(const key in $15b73f7aeef5597f$var$featureTests)$15b73f7aeef5597f$export$cde6a56f9669daf6[key] = ()=>{
    if ($15b73f7aeef5597f$var$results[key] === undefined) $15b73f7aeef5597f$var$results[key] = $15b73f7aeef5597f$var$featureTests[key]();
    return $15b73f7aeef5597f$var$results[key];
};


// Create a linear easing point for every x second
const $b177fba31032c2b0$var$resolution = 0.015;
const $b177fba31032c2b0$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $b177fba31032c2b0$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $b177fba31032c2b0$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(easing)) return (0, $15b73f7aeef5597f$export$cde6a56f9669daf6).linearEasing() ? `linear(${$b177fba31032c2b0$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing;
    else return (0, $ead554a12e40dce0$export$77290801a62f77a2)(easing) ? $b177fba31032c2b0$export$2523b8f0bd8f44cb(easing) : easing;
};
const $b177fba31032c2b0$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



function $330ddc5eb9100e1b$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $330ddc5eb9100e1b$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];




function $14b715416518df98$export$b6557f397a74f857(key) {
    if ((0, $4be6463a6552f378$export$97b5d3c90609c212)[key]) key = (0, $4be6463a6552f378$export$97b5d3c90609c212)[key];
    return (0, $4be6463a6552f378$export$8a546e9da811625d)(key) ? (0, $4be6463a6552f378$export$7bbd29b1fa8b68d4)(key) : key;
}



const $c78e3a46d208c382$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $14b715416518df98$export$b6557f397a74f857)(name);
        let value = (0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        // TODO Decide if value can be 0
        if (!value && value !== 0) {
            const definition = (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $14b715416518df98$export$b6557f397a74f857)(name);
        if ((0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};



function $2b08528401504e63$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}


const $1ec475b080df4cc4$export$844ec244b1367d54 = (value)=>typeof value === "string";


function $bf7f460c325e3a7a$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $1ec475b080df4cc4$export$844ec244b1367d54)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}


function $9ef3fcdee5d7d99d$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $9ef3fcdee5d7d99d$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $9ef3fcdee5d7d99d$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration, delay: delay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).repeat, easing: easing = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false, autoplay: autoplay = true } = options;
    const data = (0, $4ac2d59feaf07851$export$213eea93596b44f)(element);
    const valueIsTransform = (0, $4be6463a6552f378$export$8a546e9da811625d)(key);
    let canAnimateNatively = (0, $15b73f7aeef5597f$export$cde6a56f9669daf6).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $4be6463a6552f378$export$40eba1f1af915c93)(element, key);
    const name = (0, $14b715416518df98$export$b6557f397a74f857)(key);
    const motionValue = (0, $4ac2d59feaf07851$export$c0999ba824977ca6)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $2b08528401504e63$export$3cc6f911ef1fd837)(motionValue.animation, !((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $c78e3a46d208c382$export$1d567c320f4763bc).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $330ddc5eb9100e1b$export$3d2f5b3e7004e0cf)((0, $330ddc5eb9100e1b$export$388e66a97327a012)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $bf7f460c325e3a7a$export$4bcf070800a2fd35)(keyframes, definition);
        if ((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name)) {
            if ((0, $15b73f7aeef5597f$export$cde6a56f9669daf6).cssRegisterProperty()) (0, $ccd27e317ff74620$export$9fdd8c2f6f59adb0)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $15b73f7aeef5597f$export$cde6a56f9669daf6).linearEasing() && ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(easing) || (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) && easing.some((0, $6a6d195304e4357d$export$f6e2535fb5126e54)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $2600ec0fa268729d$export$7e4aa119212bc614)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $15b73f7aeef5597f$export$cde6a56f9669daf6).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(delay),
                duration: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(duration),
                endDelay: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(endDelay),
                easing: !(0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? (0, $b177fba31032c2b0$export$284d1118c33f9836)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing.map((thisEasing)=>(0, $b177fba31032c2b0$export$284d1118c33f9836)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $a9ec4c6371c8c8ef$export$8793edee2d425525));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, definition && (0, $2600ec0fa268729d$export$7e4aa119212bc614)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        if (animation && !autoplay) animation.pause();
        return animation;
    };
}


const $57d7e8b2ef7ce651$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);


function $b9a28f0b498c113a$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}




const $ff34fe8b644280e4$var$createAnimation = (factory)=>factory();
const $ff34fe8b644280e4$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration)=>{
    return new Proxy({
        animations: animationFactory.map($ff34fe8b644280e4$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $ff34fe8b644280e4$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $ff34fe8b644280e4$var$getActiveAnimation = (state)=>state.animations[0];
const $ff34fe8b644280e4$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $ff34fe8b644280e4$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($ff34fe8b644280e4$var$selectFinished)).catch((0, $a9ec4c6371c8c8ef$export$8793edee2d425525));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $2b08528401504e63$export$3cc6f911ef1fd837)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(value);
            // Fall-through
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $ff34fe8b644280e4$var$selectFinished = (animation)=>animation.finished;




function $98bb634993f4306d$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $2600ec0fa268729d$export$7e4aa119212bc614)(from) ? from : $98bb634993f4306d$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $98bb634993f4306d$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $98bb634993f4306d$export$4cf8f03b86be8175(option, i, total) {
    return (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(option) ? option(i, total) : option;
}


function $e9a68bb46f2fff46$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $b9a28f0b498c113a$export$90ceba2564a894f8)(elements);
        const numElements = elements.length;
        (0, $82adf2b309a976d9$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
        (0, $82adf2b309a976d9$export$f5708dca728d7177)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $57d7e8b2ef7ce651$export$d2312e68e1f5ad00)(options, key);
                valueOptions.delay = (0, $98bb634993f4306d$export$4cf8f03b86be8175)(valueOptions.delay, i, numElements);
                const animation = (0, $9ef3fcdee5d7d99d$export$c76cd972d26986f9)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $ff34fe8b644280e4$export$c5e4bb50450218c1)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}


const $8c32d4e44fcce1d2$export$e3607ec2d7a891c4 = (0, $e9a68bb46f2fff46$export$2a47ca22dbf0bb08)((0, $77d743c5fbee771c$export$c35d437ae5945fcd));




function $e7dee9a46833b703$export$290670472807ab5b(target, options = {}) {
    return (0, $ff34fe8b644280e4$export$c5e4bb50450218c1)([
        ()=>{
            const animation = new (0, $77d743c5fbee771c$export$c35d437ae5945fcd)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $e7dee9a46833b703$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(target) ? $e7dee9a46833b703$export$290670472807ab5b : (0, $8c32d4e44fcce1d2$export$e3607ec2d7a891c4);
    return factory(target, keyframesOrOptions, options);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c106e002a49a00cb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c106e002a49a00cb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c106e002a49a00cb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c106e002a49a00cb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04,
    __addDisposableResource: $c106e002a49a00cb$export$88ac25d8e944e405,
    __disposeResources: $c106e002a49a00cb$export$8f076105dc360e92
};



const $b5acf01800b32915$var$resizeHandlers = new WeakMap();
let $b5acf01800b32915$var$observer;
function $b5acf01800b32915$var$getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize: inlineSize, blockSize: blockSize } = borderBoxSize[0];
        return {
            width: inlineSize,
            height: blockSize
        };
    } else if (target instanceof SVGElement && "getBBox" in target) return target.getBBox();
    else return {
        width: target.offsetWidth,
        height: target.offsetHeight
    };
}
function $b5acf01800b32915$var$notifyTarget({ target: target, contentRect: contentRect, borderBoxSize: borderBoxSize }) {
    var _a;
    (_a = $b5acf01800b32915$var$resizeHandlers.get(target)) === null || _a === void 0 || _a.forEach((handler)=>{
        handler({
            target: target,
            contentSize: contentRect,
            get size () {
                return $b5acf01800b32915$var$getElementSize(target, borderBoxSize);
            }
        });
    });
}
function $b5acf01800b32915$var$notifyAll(entries) {
    entries.forEach($b5acf01800b32915$var$notifyTarget);
}
function $b5acf01800b32915$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $b5acf01800b32915$var$observer = new ResizeObserver($b5acf01800b32915$var$notifyAll);
}
function $b5acf01800b32915$export$81a0e12ec749d682(target, handler) {
    if (!$b5acf01800b32915$var$observer) $b5acf01800b32915$var$createResizeObserver();
    const elements = (0, $b9a28f0b498c113a$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $b5acf01800b32915$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $b5acf01800b32915$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $b5acf01800b32915$var$observer === null || $b5acf01800b32915$var$observer === void 0 || $b5acf01800b32915$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $b5acf01800b32915$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 || elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $b5acf01800b32915$var$observer === null || $b5acf01800b32915$var$observer === void 0 || $b5acf01800b32915$var$observer.unobserve(element);
        });
    };
}


const $72b7e49c26280576$var$windowCallbacks = new Set();
let $72b7e49c26280576$var$windowResizeHandler;
function $72b7e49c26280576$var$createWindowResizeHandler() {
    $72b7e49c26280576$var$windowResizeHandler = ()=>{
        const size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const info = {
            target: window,
            size: size,
            contentSize: size
        };
        $72b7e49c26280576$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $72b7e49c26280576$var$windowResizeHandler);
}
function $72b7e49c26280576$export$7fc81011b72cd94d(callback) {
    $72b7e49c26280576$var$windowCallbacks.add(callback);
    if (!$72b7e49c26280576$var$windowResizeHandler) $72b7e49c26280576$var$createWindowResizeHandler();
    return ()=>{
        $72b7e49c26280576$var$windowCallbacks.delete(callback);
        if (!$72b7e49c26280576$var$windowCallbacks.size && $72b7e49c26280576$var$windowResizeHandler) $72b7e49c26280576$var$windowResizeHandler = undefined;
    };
}



function $75cf0ae587d92f29$export$4380c87abf28fdf(a, b) {
    return (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(a) ? (0, $72b7e49c26280576$export$7fc81011b72cd94d)(a) : (0, $b5acf01800b32915$export$81a0e12ec749d682)(a, b);
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $6e008e5bb5808d8d$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const $b8b6249485765e21$var$maxElapsed = 50;
const $b8b6249485765e21$var$createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const $b8b6249485765e21$export$38ba9ec5092d2d70 = ()=>({
        time: 0,
        x: $b8b6249485765e21$var$createAxisInfo(),
        y: $b8b6249485765e21$var$createAxisInfo()
    });
const $b8b6249485765e21$var$keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function $b8b6249485765e21$var$updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length: length, position: position } = $b8b6249485765e21$var$keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element[`scroll${position}`];
    axis.scrollLength = element[`scroll${length}`] - element[`client${length}`];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > $b8b6249485765e21$var$maxElapsed ? 0 : (0, $6e008e5bb5808d8d$export$eab0632f7ad4f9d7)(axis.current - prev, elapsed);
}
function $b8b6249485765e21$export$55f50a00c84f0ed3(element, info, time) {
    $b8b6249485765e21$var$updateAxisInfo(element, "x", info, time);
    $b8b6249485765e21$var$updateAxisInfo(element, "y", info, time);
    info.time = time;
}





function $e81097a8ff5188c2$export$6858938830d6a6db(element, container) {
    let inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top: top, left: left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */ while(current && current.tagName !== "svg")current = current.parentNode;
        }
    }
    return inset;
}


const $fd2f2ce74d5b941d$export$e59548524dcf6540 = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};




const $a87a75a7ec1265be$export$5329d185756d2568 = {
    start: 0,
    center: 0.5,
    end: 1
};
function $a87a75a7ec1265be$export$1a4fccdf0f25754b(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if ($a87a75a7ec1265be$export$5329d185756d2568[edge] !== undefined) edge = $a87a75a7ec1265be$export$5329d185756d2568[edge];
    /**
     * Handle unit values
     */ if ((0, $1ec475b080df4cc4$export$844ec244b1367d54)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if ((0, $2600ec0fa268729d$export$7e4aa119212bc614)(edge)) delta = length * edge;
    return inset + delta;
}


const $48fd5ea0e13962ac$var$defaultOffset = [
    0,
    0
];
function $48fd5ea0e13962ac$export$1d98ea10734f1dc1(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : $48fd5ea0e13962ac$var$defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0, $2600ec0fa268729d$export$7e4aa119212bc614)(offset)) /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if ((0, $1ec475b080df4cc4$export$844ec244b1367d54)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, $a87a75a7ec1265be$export$5329d185756d2568)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, $a87a75a7ec1265be$export$1a4fccdf0f25754b)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, $a87a75a7ec1265be$export$1a4fccdf0f25754b)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}


const $97384d4a8a4becbf$var$point = {
    x: 0,
    y: 0
};
function $97384d4a8a4becbf$export$44b097f22602edfc(container, info, options) {
    let { offset: offsetDefinition = (0, $fd2f2ce74d5b941d$export$e59548524dcf6540).All } = options;
    const { target: target = container, axis: axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, $e81097a8ff5188c2$export$6858938830d6a6db)(target, container) : $97384d4a8a4becbf$var$point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : {
        width: target.clientWidth,
        height: target.clientHeight
    };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, $48fd5ea0e13962ac$export$1d98ea10734f1dc1)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, $f9be231e4d7a00b5$export$89e29e4ab65e70a9)((0, $9b3af257d77590ba$export$24dbcec0b26e6d9d)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}


function $bac8f9ef8eb51193$var$measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node != container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function $bac8f9ef8eb51193$export$9dd72aeec3645b49(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: ()=>$bac8f9ef8eb51193$var$measure(element, options.target, info),
        update: (time)=>{
            (0, $b8b6249485765e21$export$55f50a00c84f0ed3)(element, info, time);
            if (options.offset || options.target) (0, $97384d4a8a4becbf$export$44b097f22602edfc)(element, info, options);
        },
        notify: (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(onScroll) ? ()=>onScroll(info) : $bac8f9ef8eb51193$var$scrubAnimation(onScroll, info[axis])
    };
}
function $bac8f9ef8eb51193$var$scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing: easing })=>{
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing) animation.easing = (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721);
            animation.updateDuration(1);
        } else {
            const timingOptions = {
                duration: 1000
            };
            if (!easing) timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 || _b.call(_a, timingOptions);
        }
    });
    return ()=>{
        controls.currentTime = axisInfo.progress;
    };
}


const $974ce312bf5c39f3$var$scrollListeners = new WeakMap();
const $974ce312bf5c39f3$var$resizeListeners = new WeakMap();
const $974ce312bf5c39f3$var$onScrollHandlers = new WeakMap();
const $974ce312bf5c39f3$var$getEventTarget = (element)=>element === document.documentElement ? window : element;
function $974ce312bf5c39f3$export$209876d7b1ac8f3(onScroll, _a = {}) {
    var { container: container = document.documentElement } = _a, options = (0, $c106e002a49a00cb$export$3c9a16f847548506)(_a, [
        "container"
    ]);
    let containerHandlers = $974ce312bf5c39f3$var$onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        $974ce312bf5c39f3$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, $b8b6249485765e21$export$38ba9ec5092d2d70)();
    const containerHandler = (0, $bac8f9ef8eb51193$export$9dd72aeec3645b49)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!$974ce312bf5c39f3$var$scrollListeners.has(container)) {
        const listener = ()=>{
            const time = performance.now();
            for (const handler of containerHandlers)handler.measure();
            for (const handler of containerHandlers)handler.update(time);
            for (const handler of containerHandlers)handler.notify();
        };
        $974ce312bf5c39f3$var$scrollListeners.set(container, listener);
        const target = $974ce312bf5c39f3$var$getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $974ce312bf5c39f3$var$resizeListeners.set(container, (0, $75cf0ae587d92f29$export$4380c87abf28fdf)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const listener = $974ce312bf5c39f3$var$scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return ()=>{
        var _a;
        if (typeof onScroll !== "function") onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */ const containerHandlers = $974ce312bf5c39f3$var$onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const listener = $974ce312bf5c39f3$var$scrollListeners.get(container);
        $974ce312bf5c39f3$var$scrollListeners.delete(container);
        if (listener) {
            $974ce312bf5c39f3$var$getEventTarget(container).removeEventListener("scroll", listener);
            (_a = $974ce312bf5c39f3$var$resizeListeners.get(container)) === null || _a === void 0 || _a();
            window.removeEventListener("resize", listener);
        }
    };
}



let $f9ccc1fa0d22629a$var$selector = "#div_block-4-7";
(0, $974ce312bf5c39f3$export$209876d7b1ac8f3)((0, $e7dee9a46833b703$export$e3607ec2d7a891c4)($f9ccc1fa0d22629a$var$selector, {
    y: "200%",
    transform: "scale(4)"
}));
console.log("hello");

})();
//# sourceMappingURL=index.js.map
